// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"22fe3094","113":"63aad1fa"}[chunkId] + ".chunk.css";
};